import React from 'react';

import { ErrorContainerStyled } from 'modules/detail/styled';

const t = {
  404: {
    title: 'Job not found',
    description: 'Double-check the job ID, this job has either been deleted or never existed.',
  },
  500: {
    title: 'The job details couldn’t be retrieved',
    description: 'An error occurred on the server, please refresh the page.',
  },
  default: {
    title: 'Job not found',
    description: 'A technical error occurred, please contact the dev team.',
  },
};

const ErrorSection = ({ error }) => {
  const { code } = error;
  const title = t[code] ? t[code].title : t.default.title;
  const description = t[code] ? t[code].description : t.default.description;
  return <ErrorContainerStyled title={title} description={description} />;
};

export default ErrorSection;
